import get from 'lodash/get'
import { Chains } from 'modules/blockChain/chains'
import { PoolAsset } from '../constants/poolAssets'

const ONE_INCH_LINKS = {
  [Chains.Polygon]: {
    [PoolAsset.WETH]: 'https://app.1inch.io/#/137/swap/USDC/ETH',
    [PoolAsset.USDC]: 'https://app.1inch.io/#/137/swap/ETH/USDC',
  },
}

export function getLinkOneInch(chainId: Chains, asset: PoolAsset) {
  return get(ONE_INCH_LINKS, [chainId, asset])
}
